export default "__VITE_ASSET__lhupAzyw__"